



























import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import {NestedEditModel, RateRuleSelectListItem} from '@/services/api/nswag/stapiclient_generated';
import HalfSelectedCheckbox from '@/views/RateRules/RateRuleSelectNested/HalfSelectedCheckbox.vue';

interface RRSelectListItem extends RateRuleSelectListItem{
  selected: boolean;
  isOpen: boolean;
  childItems: RRSelectListItem[];
}

@Component({
  components: {
    RateRuleSelectNestedInner, HalfSelectedCheckbox
  },
})
export default class RateRuleSelectNestedInner extends Vue {
  @Prop() value!:RRSelectListItem[];

  get selectEditModels(){
    return this.value;
  }

  allChildrenSelectedRecursive(childItems: RRSelectListItem[]): boolean{
    let allSelected = true;
    childItems.forEach(x=>{
      if(!x.selected || !this.allChildrenSelectedRecursive(x.childItems)){
        allSelected = false;
      }
    })
    return allSelected;
  }

  allChildrenSelected(item: RRSelectListItem){
    return this.allChildrenSelectedRecursive(item.childItems);
  }

  @Emit('input')
  childToggled(item: RRSelectListItem){
    item.selected = item.childItems.some(x=>x.selected);
    let result = JSON.parse(JSON.stringify(this.value));

    result[result.findIndex((x: any) => x.id == item.id)] = item;

    return result;
  }

  setChildItems(childItems: RRSelectListItem[], selected: boolean){
    childItems?.forEach((x: RRSelectListItem)=>{
      x.selected = selected
      this.setChildItems(x.childItems, selected);
    })
  }

  @Emit('input')
  parentToggle(item: RRSelectListItem){
    item.selected = !item.selected;
    this.setChildItems(item.childItems, item.selected);

    let result = JSON.parse(JSON.stringify(this.value));

    result[result.findIndex((x: any) => x.id == item.id)] = item;

    return result;
  }

}
